(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        e.preventDefault();
        var id = opener.getAttribute('data-drawer-open');
        var drawer = document.getElementById(id);
        if (drawer) openDrawer(drawer, opener);
        return;
      }

      var closer = e.target.closest('[data-drawer-close]');
      if (closer) {
        var panel = closer.closest('.drawer');
        if (panel) closeDrawer(panel);
        return;
      }

      var levelOpener = e.target.closest('[data-open-level]');
      if (levelOpener) {
        var levelId = levelOpener.getAttribute('data-open-level');
        var root = levelOpener.closest('.mnav');
        if (!root) return;
        var level = root.querySelector('[data-level="' + cssEscape(levelId) + '"]');
        if (!level) return;
        level.hidden = false;
        // force reflow then animate
        void level.offsetWidth;
        level.classList.add('is-active');
        root.classList.add('is-drilled');
        // track stack for back + root dimming
        root._stack = root._stack || [];
        root._stack.push(level);
        var backBtn = level.querySelector('.mnav__back');
        if (backBtn) backBtn.focus({ preventScroll: true });
        return;
      }

      var levelCloser = e.target.closest('[data-close-level]');
      if (levelCloser) {
        var level2 = levelCloser.closest('.mnav__level');
        var root2 = levelCloser.closest('.mnav');
        if (!level2) return;
        level2.classList.remove('is-active');
        window.setTimeout(function () {
          if (!level2.classList.contains('is-active')) level2.hidden = true;
        }, 320);
        if (root2 && root2._stack) {
          root2._stack = root2._stack.filter(function (n) { return n !== level2; });
          if (!root2._stack.length) root2.classList.remove('is-drilled');
        }
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        // Prefer closing deepest mobile level first
        var openLevel = document.querySelector('.mnav__level.is-active:not(.mnav__level--root)');
        if (openLevel) {
          var back = openLevel.querySelector('[data-close-level]');
          if (back) { back.click(); return; }
        }
        document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
      }
    });

    function cssEscape(str) {
      if (window.CSS && CSS.escape) return CSS.escape(str);
      return String(str).replace(/"/g, '\\"');
    }

    function openDrawer(drawer, opener) {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var focusable = drawer.querySelector(FOCUSABLE);
      if (focusable) focusable.focus({ preventScroll: true });
      drawer._opener = opener;

      // Reset mobile drill-down when opening menu
      var mnav = drawer.querySelector('.mnav');
      if (mnav) resetMnav(mnav);
    }

    function closeDrawer(drawer) {
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (drawer._opener) {
        drawer._opener.setAttribute('aria-expanded', 'false');
        try { drawer._opener.focus({ preventScroll: true }); } catch (err) {}
      }
      window.setTimeout(function () {
        drawer.hidden = true;
        var mnav = drawer.querySelector('.mnav');
        if (mnav) resetMnav(mnav);
      }, 300);
    }

    function resetMnav(mnav) {
      mnav.classList.remove('is-drilled');
      mnav._stack = [];
      mnav.querySelectorAll('.mnav__level:not(.mnav__level--root)').forEach(function (lvl) {
        lvl.classList.remove('is-active');
        lvl.hidden = true;
      });
      var root = mnav.querySelector('.mnav__level--root');
      if (root) root.classList.add('is-active');
    }

    // Sticky / transparent state
    var headers = document.querySelectorAll('[data-header]');
    if (headers.length) {
      var onScroll = function () {
        var scrolled = window.scrollY > 4;
        headers.forEach(function (h) { h.classList.toggle('is-scrolled', scrolled); });
      };
      document.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Desktop dropdown keyboard support
    document.querySelectorAll('.hdr__nav-item.has-dropdown > a').forEach(function (link) {
      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
          var item = link.parentElement;
          if (!item.classList.contains('is-open')) {
            e.preventDefault();
            document.querySelectorAll('.hdr__nav-item.is-open').forEach(function (i) {
              if (i !== item) {
                i.classList.remove('is-open');
                var a = i.querySelector(':scope > a');
                if (a) a.setAttribute('aria-expanded', 'false');
              }
            });
            item.classList.add('is-open');
            link.setAttribute('aria-expanded', 'true');
          }
        }
        if (e.key === 'Escape') {
          link.parentElement.classList.remove('is-open');
          link.setAttribute('aria-expanded', 'false');
          link.focus();
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.hdr__nav-item.has-dropdown')) {
        document.querySelectorAll('.hdr__nav-item.is-open').forEach(function (i) {
          i.classList.remove('is-open');
          var a = i.querySelector(':scope > a');
          if (a) a.setAttribute('aria-expanded', 'false');
        });
      }
    });

    // Predictive search with product thumbnails
    document.querySelectorAll('[data-search-input]').forEach(function (searchInput) {
      var timer = null;
      var results = searchInput.closest('.drawer__body, form') &&
        (searchInput.closest('.drawer__body') || searchInput.form.parentElement).querySelector('[data-search-results]');
      // Prefer sibling results container in same drawer
      var drawerBody = searchInput.closest('.drawer__body');
      if (drawerBody) results = drawerBody.querySelector('[data-search-results]');

      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim();
        clearTimeout(timer);
        if (!results) return;
        if (query.length < 2) { results.innerHTML = ''; return; }
        timer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              if (!products.length) {
                results.innerHTML = '<p class="sr-empty">No products found</p>';
                return;
              }
              results.innerHTML = products.map(function (p) {
                var img = p.image
                  ? '<img src="' + p.image + '" alt="" width="48" height="48" loading="lazy">'
                  : '<span style="width:48px;height:48px;border-radius:8px;background:rgba(0,0,0,.06);display:inline-block"></span>';
                var price = p.price ? '<small>' + p.price + '</small>' : '';
                return '<a href="' + p.url + '">' + img +
                  '<span class="sr-meta"><strong>' + escapeHtml(p.title) + '</strong>' + price + '</span></a>';
              }).join('');
            })
            .catch(function () {});
        }, 220);
      });
    });

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    // Wishlist badge hook
    document.addEventListener('wishlist:updated', function (e) {
      var count = (e.detail && e.detail.count) || 0;
      document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
        el.textContent = count;
        el.setAttribute('data-count', count);
      });
    });

    // Swipe-to-close drawers
    document.querySelectorAll('[data-swipe-close]').forEach(function (panel) {
      var startX = null, startY = null, dragging = false;
      var side = panel.getAttribute('data-swipe-close');
      panel.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dragging = true;
      }, { passive: true });
      panel.addEventListener('touchmove', function () {
        if (!dragging) return;
      }, { passive: true });
      panel.addEventListener('touchend', function (e) {
        if (!dragging || startX === null) return;
        dragging = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dy) > Math.abs(dx)) { startX = null; return; }
        var closeThreshold = 70;
        if (side === 'left' && dx < -closeThreshold) closeDrawer(panel.closest('.drawer'));
        if (side === 'right' && dx > closeThreshold) closeDrawer(panel.closest('.drawer'));
        startX = null;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
